export const randomId = () => String(Math.random());

export const randomInt = () => Math.floor(Math.random() * 100);
